var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-speaker',
                        view: publicPath + 'sprite.svg#view-icon-speaker',
                        viewBox: '0 0 480 480',
                        title: 'icons/fonctions/speaker',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };